<template>
    <div class="profile-tabs__wrapper profile-tabs__wrapper--volunteer profile-tabs__wrapper--volunteer-payments">

        <div class="profile-tabs">
            <div class="profile-tabs__header-text">{{$store.getters.t('user_dashboard_tabs_payments')}}</div>

            <template v-if="array.length && loaded">
                <div class="profile-tabs__scroll-wrapper">
                    <div class="profile-tabs__body">

                        <div class="profile-tabs__body-item d-flex"
                             v-for="({target = null, expenditure, ...item}, index) in array" :key="index">

                            <template v-if="target && item">
                                <div class="profile-tabs__body-header">
                                    <a :href="`/pets/${item.target_id}`" class="profile-tabs__body-image" v-if="item.target_type.indexOf('Pet') >= 0">
                                        <img :src="`/storage/${target.avatar.path.replace('original', 'avatar')}`" :alt="target.name" v-if="target.avatar">
                                        <span v-else v-text="getUserPM(target.name || 'Anonymous')"></span>
                                    </a>
                                    <a :href="`/projects/${item.target_id}`" class="profile-tabs__body-image" v-if="item.target_type.indexOf('Project') >= 0">
                                        <img :src="`/storage/${target.avatar.path.replace('original', 'avatar')}`" :alt="target.name" v-if="target.avatar">
                                        <span v-else v-text="getUserPM(target.name || 'Anonymous')"></span>
                                    </a>
                                </div>

                                <div class="profile-tabs__body-content">
                                    <div class="profile-tabs__body-info d-flex">
                                        <span>
                                            {{item.amount}} USD
                                        </span>
                                        <template v-if="item.statusClass && item.statusKey">
                                            <div>
                                                <span class="profile-tabs__body-info-label" :class="item.statusClass">{{$store.getters.t(item.statusKey)}}</span>
                                            </div>
                                        </template>
                                    </div>

                                    <a :href="`/pets/${item.target_id}`" class="profile-tabs__body-name" v-if="item.target_type.indexOf('Pet') >= 0">{{ target.name }}</a>
                                    <a :href="`/projects/${item.target_id}`" class="profile-tabs__body-name" v-if="item.target_type.indexOf('Project') >= 0">{{ target.name }}</a>
                                    <div v-if="item.ticket_url">
                                    <a :title="$store.getters.t('user_dashboard_ticket_title')" class="profile-tabs__body-name" :href="item.ticket_url" target="_blank">
                                        <span class="lnr lnr-file-empty"></span>
                                            {{$store.getters.t('user_dashboard_ticket_text')}}
                                        </a>
                                    </div>

                                    <div class="profile-tabs__body-meta">{{getNoticeDate(item.created_at)}}</div>
                                </div>
                            </template>

                        </div>

                    </div>
                </div>
            </template>
            <template v-else-if="!loaded">
                <div class="profile-dashboard__pets-slider profile-dashboard__pets-slider--empty d-flex">
                    <div class="LoaderBalls">
                        <div class="LoaderBalls__item"></div>
                        <div class="LoaderBalls__item"></div>
                        <div class="LoaderBalls__item"></div>
                    </div>
                </div>
            </template>
            <template v-else>
                <div class="profile-tabs__body profile-tabs__body--empty d-flex">

                    {{$store.getters.t('facilities_list_empty')}}

                </div>
            </template>


        </div>

    </div>
</template>

<script>

import Tabs from '../tabs/Tabs';
import Tab from '../tabs/Tab';

export default {
    name: "UserDashboardTabs",
    props: ['user'],
    components: {Tab, Tabs},
    data() {
        return {
            array: [],
            loaded: false,
        }
    },

    async mounted() {
        await this.getDonated()
    },

    methods: {

        async getDonated() {

            const params = {
                per_page: 20,
                page: 1,
            }

            try {
                const {data} = await axios.get( `/api/user/expenditure-requests`, { params: params } )
                this.array = data.data

                this.array = this.array.map((_item) => {

                    if( _item.status ){

                        switch ( _item.status ){
                            case 'created':
                                _item.statusClass = 'created';
                                _item.statusKey = 'user_dashboard_payment_status_created';
                                break;
                            case 'approved':
                                _item.statusClass = 'approved';
                                _item.statusKey = 'user_dashboard_payment_status_approved';
                                break;
                            case 'rejected':
                                _item.statusClass = 'rejected';
                                _item.statusKey = 'user_dashboard_payment_status_rejected';
                                break;
                            case 'funded':
                            case 'processed':
                                _item.statusClass = 'funded';
                                _item.statusKey = 'user_dashboard_payment_status_paid';
                                break;
                            default:
                                break;
                        }

                    }

                    return _item

                })

            } catch (e) {
                console.log(e)
            }
        },

        getNoticeDate(timestamp){
            const dateUTC = Date.parse(timestamp)
            const dateNow = Date.now()
            const totalMinutes = Math.floor((dateNow - dateUTC) / 60000)

            if (totalMinutes < 60) {
                if (totalMinutes <= 1) return this.$store.getters.t('common_minute_ago')
                return `${totalMinutes} ${this.$store.getters.t('common_minutes_ago')}`
            } else if (totalMinutes < 1440) {
                const hours = Math.floor(totalMinutes / 60)
                if (hours === 1) return this.$store.getters.t('common_hour_ago')
                return `${hours} ${this.$store.getters.t('common_hours_ago')}`
            } else {
                const days = Math.floor(totalMinutes / 1440)
                if (days === 1) return this.$store.getters.t('common_day_ago')
                return `${days} ${this.$store.getters.t('common_days_ago')}`
            }
        },

        getUserPM(name) {
            let nameArray = name.trim().split(' ');
            return nameArray[0][0] + ((nameArray[1]) ? nameArray[1][0] : '') + '';
        },
    },

    watch: {
        array() {
            setTimeout(() => {
                this.loaded = true
            }, 1000)
        }
    },


}
</script>

<style lang="scss" scoped>

.profile-tabs__body-name{
 .lnr{
     font-size: 14px;
 }
}

</style>
